<ng-template [ngIf]="request">
    <form [formGroup]="censimentoForm" (ngSubmit)="update();">

        <div class="row">
            <div comboModInput class="col-sm-4" [labelInput]="'Provenienza'" formControlName="tipoProvenienzaDocumento"
                [labelOption]="'descrizione'" [optionsCombo]="provenienzaOptions" [mandatory]="true"
                [objectReference]="request.tipoProvenienzaDocumento" [ngModel]="request.tipoProvenienzaDocumento" [submitPending]="!inserimento"
                [control]="censimentoForm.controls['tipoProvenienzaDocumento']" (onReturn)="request.tipoProvenienzaDocumento = $event"></div>
            <div comboModInput class="col-sm-4" [labelInput]="'Tipo'" formControlName="tipoDocumento" [submitPending]="!inserimento"
                [labelOption]="'descrizione'" [optionsCombo]="tipoDocumentoOptions" [mandatory]="true"
                [objectReference]="request.tipoDocumento" [ngModel]="request.tipoDocumento"
                [control]="censimentoForm.controls['tipoDocumento']" (onReturn)="request.tipoDocumento = $event">
            </div>
            <div naturalNumberInput [control]="censimentoForm.controls['quantita']" class="col-sm-4" [mandatory]="true"
                [labelInput]="'Quantitativo minimo'" [maxLength]="'4'" formControlName="quantita"
                (onModelChange)="request.quantita = $event"
                [(ngModel)]="request.quantita"></div>
        </div>

        <div class="row">
            <p class="mandatory col-sm-12">
                <em>* Campi obbligatori</em>
            </p>
        </div>
        <div class="row">
            <p class="col-sm-3 col-xs-6">
                <button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
            </p>
            <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Salva'"
                [disabled]="!censimentoForm.valid || !isQuantitaValid()"></p>
        </div>
    </form>
</ng-template>